import React, { useEffect, useState } from 'react';
import { Modal } from '../Common/Modal';
import { review as reviewMessages } from '../../utils/validationMessages';
import '../Common/ElectronicSign.css';

const REMARKS_MAX_LENGTH = 2000;

/**
 * Skip Visit Management only — remark required, no password.
 * Does not use ElectronicSign (other pages keep password + remark).
 */
const SiteVisitAssignmentRemarkModal = ({ show, saving, onClose, onSave }) => {
  const [remark, setRemark] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      setRemark('');
      setError('');
    }
  }, [show]);

  const handleSave = () => {
    const trimmed = (remark || '').trim();
    if (!trimmed) {
      setError(reviewMessages.remarksRequired);
      return;
    }
    onSave(trimmed);
  };

  const handleClose = () => {
    if (saving) return;
    setRemark('');
    setError('');
    onClose();
  };

  if (!show) return null;

  return (
    <Modal
      isOpen={show}
      onClose={handleClose}
      title="Enter Remark"
      size="medium"
      showCloseButton={true}
      overlayClassName="electronic-sign-overlay"
      footer={
        <div className="electronic-sign-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Saving…' : 'Save'}
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={handleClose}
            disabled={saving}
          >
            Cancel
          </button>
        </div>
      }
    >
      <div className="electronic-sign-body">
        <div className="form-group">
          <label className="required">Remark</label>
          <textarea
            className={`form-control ${error ? 'is-invalid' : ''}`}
            rows={2}
            placeholder={`Enter Remark (max ${REMARKS_MAX_LENGTH} characters)`}
            value={remark}
            onChange={(e) => {
              let next = e.target.value;
              if (next.length > REMARKS_MAX_LENGTH) next = next.slice(0, REMARKS_MAX_LENGTH);
              setRemark(next);
              if (error) setError('');
            }}
            maxLength={REMARKS_MAX_LENGTH}
          />
          {error && <div className="electronic-sign-field-error text-danger">{error}</div>}
        </div>
      </div>
    </Modal>
  );
};

export default SiteVisitAssignmentRemarkModal;
